import { render, staticRenderFns } from "./PaymentReceiptAttachmentDialog.vue?vue&type=template&id=4af6ecce&scoped=true"
import script from "./PaymentReceiptAttachmentDialog.vue?vue&type=script&lang=js"
export * from "./PaymentReceiptAttachmentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af6ecce",
  null
  
)

export default component.exports